
import React from 'react';
import { getLocalizedStrings } from './utils_android/LocalizedStrings';
import {DebounceInput} from 'react-debounce-input';
import { getRequestParams, getRequestUrl } from './utils_android/CookieHelper';
import qs from 'querystring'
import android_icon from './custom_icons/android.svg'
import ios_icon from './custom_icons/apple.svg'
import close_order from './custom_icons/close_order.svg'
import InputLoader from './utils_android/InputLoader';
import AppsDropdown from './AppsDropdown';
import { getUrlParameter } from './utils_android/UrlHelperAndroid';
import { getHttpParams } from './analyze_review/utils/Utils';
var strings = getLocalizedStrings()
var notDisplay = {display : 'none'}
var display = {display : 'block', marginTop : '7px'}
var androidUrl = "https://play.google.com/store/apps/details?id="
var iosUrl = "https://itunes.apple.com/ru/app/id"
class NewOrderSearchLine extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            pickedAppIcon : "",
            pickedAppDeviceIcon : "",
            searchText : "",
            type_os : "",
            isLoading : false,
            isShowApps : false,
            appsList : [],
            bundle : ""
        }
        this.searchTextChanged = this.searchTextChanged.bind(this)
        this.clearSearchLine = this.clearSearchLine.bind(this)
       
    }
    componentWillMount(){
        if (this.props.preOrderBundle){
            var url = ""
            if (this.props.preOrderTypeOs == "android"){
                url = androidUrl + this.props.preOrderBundle
            } else {
                url = iosUrl + getUrlParameter("app_id")
            }
            this.searchApp(url)
       }
    }
    searchTextChanged(event){
        if (event){
            var text = event.target.value
            this.setState({searchText: text})
            if (text.includes("https://")){
                this.searchApp(text)
            } else {
                this.searchAppsByText(text)
            }
            if (this.props.inputSearchChanged){
                this.props.inputSearchChanged(text)
            }
        }
    }

    searchApp = (text) => {
       // $scope.progressPackageStyle = visibleStyle;
       // closeAppsList()
       this.setState({isLoading : true})
       var params = getRequestParams()
       params.url = text
       fetch(getRequestUrl() + "getAppInfo", getHttpParams(params)).then((response) => response.json())
       .then((responseData) => {
        if (responseData.response == -1) {
            //closeAppsList()
        } else if(responseData.response == 1){
            this.setInfoData(responseData)
        } else if (responseData.response == -20) {
            this.setState({pickedAppIcon : "", pickedAppDeviceIcon: ""})
        }
            this.setState({isLoading : false, isShowApps : false})
       })
       
      
    }
    setInfoData = (data) => {
        var info = data.info
        var name = ""
        var icon = ""
        var type_os = ""
        var price = ""
        var version_os = ""
        var id = ""
        var category = ""
        if (data.type_os == "ios"){
            name = info.trackCensoredName
            icon = info.icon
            type_os = "ios"
            price = info.price
            version_os = info.requiredOsVersion
            id = info.id
            category = info.genres[0]
            this.setState({pickedAppIcon : icon, searchText : name, pickedAppDeviceIcon : ios_icon, type_os : "ios", bundle :  info.appId})
        } else {
            name = info.title
            icon = info.icon
            type_os = "android"
            price = info.price
            version_os = info.version_os
            id = info.appId
            category = info.genre
            this.setState({pickedAppIcon : icon, searchText : name, pickedAppDeviceIcon : android_icon, type_os : "android", bundle :  info.appId})
        }
        this.props.appPicked(name, icon, type_os, info.appId, price, version_os, id, category)
    } 

    searchAppsByText = (text) => {
    //$scope.appsListStyle = invisStyle
        this.setState({isLoading : true})
        var params = getRequestParams()
        params.query = text
        fetch(getRequestUrl() + "searchAppAllData", {
            method: 'POST',
            headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'},
            body: qs.stringify(params)
        }).then((response) => response.json())
        .then((responseData) => {
            if(responseData.response == 1 && responseData.gplay && responseData.appstore){
                    var apps2 = []
                    responseData.gplay.forEach(element => {
                      var app = {
                        'bundle': element.appId,
                        'name': element.title,
                        'type_os': 'android',
                        'appstore_id': element.appId,
                        'icon': element.icon
                       
                      }
                      apps2.push(app)
                    });
                    responseData.appstore.forEach(element => {
                      var app = {
                        'bundle': element.bundleId,
                        'name': element.trackName,
                        'type_os': 'ios',
                        'appstore_id': element.trackId,
                        'icon': element.icon
            
                      }
                      apps2.push(app)
                    });
                    this.setState({appsList : apps2, isShowApps : true, isLoading : false})              
            } else {
                this.setState({isLoading : false})        
            } 
        })

    
    }
    onAppPicked = (app) => {
       
        if (app.type_os == "android"){
            this.searchApp(androidUrl + app.bundle)
        } else {
            this.searchApp(iosUrl + app.appstore_id)
        }
         this.setState({isShowApps : false})
        // this.props.appPicked(app.icon, app.name, app.type_os, app.bundle, app.price_app_in_store, app.version_os, app.appstore_id, app.category)
    }
    
    getMyApps = () => {
        var params = getRequestParams()
        fetch(getRequestUrl() + "getMyApps", {
            method: 'POST',
            headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'},
            body: qs.stringify(params)
        }).then((response) => response.json())
        .then((responseData) => {
            if (responseData.response == 1) {
                
                this.setState({appsList : responseData.apps.reverse()})
                
              }
        })
    }
    toogleApps = () => {
        if (this.state.appsList && this.state.appsList.length > 0){
            this.setState({isShowApps : !this.state.isShowApps})
        }
        
    }
    onCloseApps = () => {
        this.setState({isShowApps : false})
    }
    componentDidMount(){
        this.getMyApps()
    }
    clearSearchLine(){
        this.setState({pickedAppIcon : "", pickedAppDeviceIcon : "", searchText : "", isShowApps : false})
    }
    render() {
        return (
            <div className="order_row">
                <div className="input_container_border search_test_border">
                        <img style={(this.state.pickedAppIcon == "" || this.state.searchText == "") ? notDisplay : display} className="img_choose_app img_input_icon" src={this.state.pickedAppIcon} alt=""/>
                        <img style={(this.state.pickedAppDeviceIcon == "" || this.state.searchText == "") ? notDisplay : display} src={this.state.type_os == "android" ? android_icon : ios_icon} className="img_device_icon_input"/>
            
                        <DebounceInput autoComplete="off" debounceTimeout={500} onClick={this.toogleApps}
                         onChange={this.searchTextChanged} className="input_text_search" placeholder={strings.inputName} value={this.state.searchText}/>
                        {this.state.isLoading ? <InputLoader style={{top : "6px"}}/> : <div/>}
                        {(this.state.searchText != "" && this.state.searchText != undefined && !this.state.isLoading) && <img onClick={this.clearSearchLine} src={close_order} className="search_close_order_icon hover" />}
                        {this.state.isShowApps ? <AppsDropdown onCloseApps={this.onCloseApps} onAppPicked={this.onAppPicked} apps={this.state.appsList} /> : <div/>}
                       
                </div>
                <div className="input_description_container">
                    <p className="input_description_text">{this.props.description}</p>
                </div>
          </div>
        );
    }
}
export default NewOrderSearchLine;

